// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__EbIwG","requiredAsterisk":"Info_requiredAsterisk__3Kp5o"};